import { ComponentProps } from 'react';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import Table from 'antd/es/table';
import clsx from 'clsx';

import { type OpTableRecordType } from './types';

import './OpTableCore.scss';

export type OpTableCorePropsType<RecordType extends OpTableRecordType> =
  ComponentProps<typeof Table<RecordType>> & {
    loading?: boolean;
    testId?: string;
    gtm?: string;
  };

export const OpTableCore = <RecordType extends OpTableRecordType>({
  className,
  loading = false,
  testId = 'op-table-core',
  gtm,
  ...tableProps
}: OpTableCorePropsType<RecordType>) => {
  return (
    <Table
      data-testid={testId}
      data-gtm={gtm}
      className={clsx('op-table-core', className)}
      size="middle"
      loading={{
        spinning: loading,
        indicator: <LoadingOutlined data-testid={'op-table-loader'} />,
      }}
      {...tableProps}
    />
  );
};
